import { memoizeFunction } from '@fluentui/react/lib/Utilities';
import { CoauthorGalleryPalette } from './coauthorGalleryPalette';
import { mergeStyles, HighContrastSelector } from '@fluentui/react/lib/Styling';

export const getPersonaCoinStyles = memoizeFunction(
  (palette: CoauthorGalleryPalette, coauthorColor: string, hasRing?: boolean) => {
    return mergeStyles({
      padding: hasRing ? palette.ringPadding : palette.ringPadding + palette.ringWidth,
      border: hasRing ? `${palette.ringWidth}px solid ${coauthorColor}` : undefined,
      selectors: {
        [HighContrastSelector]: {
          borderColor: 'white',
        },
      },
      borderRadius: '50%',
    });
  }
);
